import { useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { actions } from '../../../../context';
import moment from 'moment';
import { Facebook } from 'react-spinners-css';

const pluginconfigurationData = {
    pluginId: '',
    pluginVersion: {},
    targetState: '',
};

const targetstateData = [
    { id: '1', state: 'Cached', value: 'Cached' },
    { id: '2', state: 'Installed', value: 'Installed' },
    { id: '3', state: 'Running', value: 'Running' },
];

const PluginClientManifestConfigurationModal = ({
    pluginId,
    defaultVersion,
    toggle,
    isOpen = false,
    addConfigurationBehavior,
}) => {
    const dispatch = useDispatch();

    const [isLoadingVersion, setIsLoadingVersions] = useState(true);
    const [pluginVersions, setPluginVersions] = useState([]);
    const [selectedVersion, setSelectedVersion] = useState(defaultVersion);
    const [selectedState, setSelectedState] = useState(
        targetstateData[0].value
    );

    const { control, handleSubmit } = useForm();

    const refreshPluginVersions = useCallback(
        () =>
            dispatch(actions.missionControl.getPluginVersions(pluginId)).then(
                (res) => {
                    setPluginVersions(res || []);
                    setIsLoadingVersions(false);
                }
            ),
        [dispatch, pluginId]
    );

    const close = useCallback(() => {
        toggle();
    }, [toggle]);

    const submit = async (vals) => {
        let state = {
            isCached: false,
            isInstalled: false,
            isRunning: false,
        };

        if (selectedState === 'Cached') {
            state = {
                ...state,
                isCached: true,
                isInstalled: false,
                isRunning: false,
            };
        } else if (selectedState === 'Installed') {
            state = {
                ...state,
                isCached: true,
                isInstalled: true,
                isRunning: false,
            };
        } else {
            state = {
                ...state,
                isCached: true,
                isInstalled: true,
                isRunning: true,
            };
        }

        try {
            let configuration = {
                ...pluginconfigurationData,
                pluginId: pluginId,
                pluginVersion: pluginVersions.find(
                    (obj) => obj.id === selectedVersion
                ).version,
                targetState: state,
            };

            addConfigurationBehavior(configuration);
        } catch (err) {
            //nom nom. should do something about this
            console.error(err);
        }
        toggle();
    };

    const handleSelectedVersionChange = (event) => {
        setSelectedVersion(event.target.value);
    };

    const handleSelectedStateChange = (event) => {
        setSelectedState(event.target.value);
    };

    const modalProps = {
        className: 'text-light',
        style: { minWidth: '30vw' },
        backdrop: 'static',
    };

    useEffect(() => {
        if (isOpen) refreshPluginVersions();
        // eslint-disable-next-line
    }, [dispatch, isOpen]);

    const truncateString = (str, maxLength) => {
        if (str.length <= maxLength) {
            return str;
        }

        return str.slice(0, maxLength) + '...';
    };

    return (
        <Modal
            className="text-light"
            centered
            isOpen={isOpen}
            toggle={close}
            {...modalProps}>
            <form onSubmit={handleSubmit(submit)}>
                <ModalHeader>Add Configuration</ModalHeader>
                <ModalBody>
                    {isLoadingVersion ? (
                        <h2 className="m-4 text-center">
                            <Facebook color="#eee" />
                        </h2>
                    ) : (
                        <div>
                            <div>
                                <h6 className="my-1">Plugin Versions:</h6>
                                <Controller
                                    control={control}
                                    name={'pluginversions'}
                                    defaultValue={defaultVersion}
                                    render={() => (
                                        <div>
                                            <select
                                                name={'pluginversions'}
                                                id={'pluginversions'}
                                                className="form-control w-75 p-2 rounded mb-4"
                                                value={selectedVersion}
                                                onChange={(e) =>
                                                    handleSelectedVersionChange(
                                                        e
                                                    )
                                                }>
                                                {pluginVersions.map((item) => (
                                                    <option
                                                        key={item.id}
                                                        value={item.id}>
                                                        {item?.version +
                                                            ' - ' +
                                                            truncateString(
                                                                item.description,
                                                                40
                                                            ) +
                                                            ` (${moment
                                                                .utc(
                                                                    item?.releaseDate
                                                                )
                                                                .local()
                                                                .format(
                                                                    'M/D/YYYY LT'
                                                                )})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                />
                            </div>
                            <div>
                                <h6 className="my-1">Target State:</h6>
                                <Controller
                                    control={control}
                                    name={'targetstate'}
                                    render={() => (
                                        <div>
                                            <select
                                                name={'targetstate'}
                                                id={'targetstate'}
                                                className="form-control w-50 p-2 rounded mb-4"
                                                value={selectedState}
                                                onChange={(e) =>
                                                    handleSelectedStateChange(e)
                                                }>
                                                {targetstateData.map((item) => (
                                                    <option
                                                        key={item.id}
                                                        value={item.value}>
                                                        {item.state}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" className="border" onClick={close}>
                        Cancel
                    </Button>
                    <Button type="submit" color="success" className="border">
                        Submit
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default PluginClientManifestConfigurationModal;
